import { type ZodString, z } from 'zod';

import { CreateUserInputSchema, UpdatedUserInputSchema } from 'APIzod';

const phoneValidation = z
    .string()
    .optional()
    .refine(val => !val || /^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/.test(val), {
        error: 'Please insert a number with a valid structure',
    });

export const createUserFormSchema = () => {
    const base = CreateUserInputSchema();
    return base.extend({
        id: z.string().optional(),
        firstName: (base.shape.firstName as ZodString).max(255, 'Cannot contain more than 255 characters'),
        lastName: (base.shape.lastName as ZodString).max(255, 'Cannot contain more than 255 characters'),
        phone: phoneValidation,
        city: z.string().optional(),
        country: z.string().optional(),
        email: z
            .string()
            .min(1, 'Email is required')
            .regex(
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                "We can't recognise the structure, please check if it's correct (e.g. example@example.com)"
            ),
        roles: z.array(z.uuid()).min(1, 'At least one role is required'),
        teams: z.array(z.uuid()),
    });
};

export const editUserFormSchema = () => {
    const base = UpdatedUserInputSchema();
    return base.extend({
        id: z.string().optional(),
        firstName: (base.shape.firstName as ZodString).max(255, 'Cannot contain more than 255 characters'),
        lastName: (base.shape.lastName as ZodString).max(255, 'Cannot contain more than 255 characters'),
        phone: phoneValidation,
        city: z.string().optional(),
        country: z.string().optional(),
        email: z.string().min(5),
        roles: z.array(z.uuid()).min(1, 'At least one role is required'),
        teams: z.array(z.uuid()),
    });
};
